import * as Variations from './Variations'
import { HtmlBuilder } from './HtmlBuilder'
import { BlogPostsFactory } from '../../factories/BlogPostsFactory'
import { EditorComponentContract } from '../EditorComponentContract'

export class BlogPosts extends EditorComponentContract {
	constructor() {
		super(Variations)
		this.htmlBuilder = HtmlBuilder
		this.factory = new BlogPostsFactory
	}

	elementIds() {
		return ['id']
	}

	elementClasses() {
		return [
			'classes',
			'readMoreContainerClasses',
			'tagsClasses',
			'authorClasses',
			'categoriesClasses',
			'readMoreClasses',
			'contentClasses',
			'titleClasses',
			'descriptionClasses',
			'dateClasses',
		]
	}

	elementContents() {
		return [
			'showCategories', 'showDescription',  'showReadMore', 'readMoreText', 'showPublishedDate',
			'showTags', 'showAuthor', 'blocks', 'filter', 'postsGrid', 'showImage', 'showTitle'
		]
	}

	elementStyles() {
		return [
			{id: 'id', element: 'id', styles: 'styles', selector: '#', variation: null},
			{element: 'class', styles: 'titleStyles', selector: '.wf-blog-posts-title' },
			{element: 'class', styles: 'tagsStyles', selector: '.wf-blog-posts-tags'},
			{element: 'class', styles: 'authorStyles', selector: '.wf-blog-posts-author'},
			{element: 'class', styles: 'contentStyles', selector: '.wf-blog-posts-content'},
			{element: 'class', styles: 'categoriesStyles', selector: '.wf-blog-posts-categories'},
			{element: 'class', styles: 'readMoreStyles', selector: '.wf-blog-posts-read-more' },
			{element: 'class', styles: 'descriptionStyles', selector: '.wf-blog-posts-description' },
			{element: 'class', styles: 'dateStyles', selector: '.wf-blog-posts-date' },
		]
	}

	info() {
		return {
			name: 'BlogPosts',
			icon: 'fa-file-alt',
			variations: this.variationsInfo()
		}
	}
}